module.exports = __webpack_public_path__ + "media/images/element/add-course-e5b463f37901fdad7af38743c8cc9bf7.svg";